import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-reporting-image.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "New! AI-Powered Reporting Suite";

const ReportingFeature = () => (
  <HeroSection title={title} className="relative h-full flex-col-reverse md:flex-row-reverse">
    <HeroSection.Content className="w-full z-[1] md:w-1/2">
      <HeroSection.Header className="md:items-start">
        <Heading tag="h2">{title}</Heading>
      </HeroSection.Header>
      <HeroSection.Description>
        Oh yes, we did! Enerflo built the best reporting suite in the industry for U.S. based residential solar
        companies of all types and sizes. Get valuable insights into your business operations like never before, and
        gain an edge on your competition.
      </HeroSection.Description>
      <HeroSection.Action className="btn-navy md:text-center" href="/features/reporting">
        Learn more about Enerflo’s Reporting Suite
      </HeroSection.Action>
    </HeroSection.Content>

    <figure className="flex-grow p-6 w-full xs:w-3/4 md:w-1/2">
      <Image
        src={FigureImage}
        alt="Enerflo AI-Powered Solar Reporting & Analytics Software."
        layout="responsive"
        quality={100}
        placeholder="blur"
        className="crispImage"
        sizes="(min-width: 768px) 50vw, 100vw"
        lazyBoundary="400px"
      />
    </figure>
  </HeroSection>
);

export default ReportingFeature;
